import { api } from './client';
import type { NoteDocument, TripNote } from '../types';

export const notesApi = {
  list: (tripId: string) =>
    api.get<TripNote[]>(`/trips/${tripId}/notes`).then(r => r.data),
  create: (tripId: string, data: { title?: string; content?: string }) =>
    api.post<TripNote>(`/trips/${tripId}/notes`, data).then(r => r.data),
  update: (tripId: string, noteId: string, data: { title?: string; content?: string }) =>
    api.patch<TripNote>(`/trips/${tripId}/notes/${noteId}`, data).then(r => r.data),
  delete: (tripId: string, noteId: string) =>
    api.delete(`/trips/${tripId}/notes/${noteId}`),
  uploadDocument: (tripId: string, noteId: string, file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.post<NoteDocument>(
      `/trips/${tripId}/notes/${noteId}/documents`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    ).then(r => r.data);
  },
  deleteDocument: (tripId: string, noteId: string, docId: string) =>
    api.delete(`/trips/${tripId}/notes/${noteId}/documents/${docId}`),
};
